import classie from 'desandro-classie';

export default function() {
  function sizeOnScroll() {
    window.addEventListener('scroll', function(e){
      var distanceY = window.pageYOffset || document.documentElement.scrollTop,
        shrinkOn = 0,
        header = document.querySelector("#menu");
      if (distanceY > shrinkOn) {
        classie.add(header,"is-smaller");
      } else {
        if (classie.has(header,"is-smaller")) {
          classie.remove(header,"is-smaller");
        }
      }
    });
  }

  window.onload = sizeOnScroll();
}
